import { Component, ElementRef, Inject, OnDestroy, OnInit, Optional, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatDialogCloseEvent, DocumentType } from '../../../const';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';
import { HelperMethods } from '../../common/helper-methods.service';
import { ToastrService } from 'ngx-toastr';
import { DtoSchoolUser } from '../../../models/school.model';
import { Role, RolePayload } from '../../../models/role.model';
import { DtoPackage } from '../../../models/package-center.model';
import { PackageService } from '../../package-center/package/package.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { SharedService } from '../../../shared/services/shared.service';
import { MatAccountService } from '../../mat-account/mat-account.service';
import { ConfirmDialogComponent } from '../../mat-account/confirm-dialog/confirm-dialog.component';
import { EditUserRoleComponent } from '../../user-center/user-role/edit-user-role/edit-user-role.component';
import { SchoolService } from '../school.service';
import * as XLSX from 'xlsx';
import { RoleMaster } from '../../user-center/user-role/user-role.component';
import { MatSelectChange } from '@angular/material/select';

interface SchoolUserUploadFileList {
  schoolUserMailId: string | null;
  files: File[];
}

@Component({
  selector: 'app-add-school-user',
  templateUrl: './add-school-user.component.html'
})
export class AddSchoolUserComponent implements OnInit, OnDestroy {

  @ViewChild('uploadFileInput') uploadFileInput: ElementRef | undefined;
  userDetail: DtoSchoolUser = {} as DtoSchoolUser;
  createUserForm: FormGroup = new FormGroup({
      schoolUserId: new FormControl(0),
      schoolId: new FormControl(0),
      title: new FormControl('', [Validators.required]),
      firstName: new FormControl('', [
        Validators.required,
        Validators.pattern('^.*[a-zA-Z]+.*$ ?'),
      ]),
      lastName: new FormControl('', [
        Validators.required,
        Validators.pattern('^.*[a-zA-Z]+.*$ ?'),
      ]),
      emailId: new FormControl('', [
        Validators.required,
        Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$"),
      ]),
      role: new FormControl([] as Role[], [Validators.required]),
      contactNumber: new FormControl('', [
        this.helperMethods.PhoneNumberValidator(),
      ])
  });
  phoneNumberUtil = PhoneNumberUtil.getInstance();
  isEditUser: boolean = false;
  canEditUser: boolean = false;
  roles: Role[] = [];
  groupedRoles: { [key: string]: Role[] } = {};
  assignedPackageId: number = 0;
  package: DtoPackage = {} as DtoPackage;
  showPackageDetails: boolean = false;
  isAdmin: boolean = false;
  isActive: boolean = true;
  isAccountActivated: boolean = false;
  @ViewChild('schoolUserFileInput') schoolUserFileInputs: ElementRef | undefined;
  schoolUserUploadFileList: SchoolUserUploadFileList[] = [];
  maxSize: number = 1 * 1024 * 1024; // 1 MB in bytes
  subscription: Subscription = new Subscription();
  selectedFileCount: number = 0;
  schoolId: number = 0;
  clientAccountId: number = 0;
  isBulkUpload : boolean = false;
  excelData: any[] = [];
  userEmail: string = "";
  availableNumberOfSchoolUsersToCreate: number = 0;
  
  constructor(
    @Optional() public dialogRef: MatDialogRef<AddSchoolUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private helperMethods: HelperMethods,
    private toasterService: ToastrService,
    private packageService: PackageService,
    private sharedService: SharedService, 
    private matAccountService: MatAccountService,
    public dialog: MatDialog,
    public schoolService: SchoolService
  ) {  
    
  }

  ngOnInit(): void {
    this.userEmail = sessionStorage.getItem('user_email')!;
    this.assignedPackageId = this.data.assignedPackageId;
    var allowedRoles: Role[] = this.data.roles;
    
    if (!allowedRoles.some(r => r.roleId === Number(RoleMaster.SchoolAdmin)))
    {
      allowedRoles = [{
        roleId: Number(RoleMaster.SchoolAdmin),
        roleName: 'School Admin',
        isActive: true
      } as Role, ...this.data.roles];
    }

    this.roles = allowedRoles;
    this.groupedRoles = this.getGroupedRolws(allowedRoles);
    
  
    this.schoolId = this.data.schoolId;
    this.clientAccountId = this.data.clientAccountId;

    if(this.data.userDetail.emailId || this.data){
      this.availableNumberOfSchoolUsersToCreate = this.data.availableNumberOfSchoolUsersToCreate;
      
      //let parsedNumber;
      //if(this.data.isBulkUploadEdit){
        //this.isEditUser = false; //set to true always below
      //}
      
      // if(this.data?.userDetail?.contactNumber?.toString()){
      //   parsedNumber = this.phoneNumberUtil.parse(this.data.userDetail.contactNumber?.toString());
      // }
      let countryCode = this.data.userDetail.countryCode ? 
                        this.data.userDetail.countryCode : 
                        this.phoneNumberUtil.parse(this.data.userDetail.contactNumber?.toString()).getCountryCode()!;
      let nationalNumber = this.data.userDetail.phoneNumber ?
                           this.data.userDetail.phoneNumber :
                           this.phoneNumberUtil.parse(this.data.userDetail.contactNumber?.toString()).getNationalNumber();

      this.isEditUser = true;
      
      this.createUserForm.patchValue(this.data.userDetail);
      this.createUserForm.controls['emailId'].setValue(this.data.userDetail.emailId);
      this.setPhoneNumber(countryCode.toString(), nationalNumber.toString());
      this.isAdmin = this.data.userDetail.isAdmin;
      this.isActive = this.data.userDetail.isActive;
      this.canEditUser=this.isActive;
      this.isAccountActivated = this.data.userDetail.isAccountActivated;

      if(this.data.userDetail.role){
        let roleList = this.roles.filter((role: Role) => {
          return this.data.userDetail.role.some((userRole: Role) => role.roleId === userRole.roleId);
        });
        this.createUserForm.controls['role'].setValue(roleList);
      }
    }

    this.getPackageByPackageId(this.assignedPackageId);

    this.subscription.add(this.sharedService.doFileUpload.subscribe((data) => {
      if(data){
        this.uploadFromLocal(data, true);
      }
    }));
  }

  getGroupedRolws(allowedRoles: Role[]):{[key:string]: Role[]}
  {
    return allowedRoles.reduce((result, role) => 
      {
        const isAudience = role.roleId > Number(RoleMaster.SchoolAdmin);
        const key = isAudience ? 'Audience' : 'Role';
        result[key] = result[key] || [];
        result[key].push(role);
        return result;
      },{} as {[key:string]: Role[]});
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  onRoleChange(event: MatSelectChange) {
    const selectedRoles: Role[] = event.value;
    const schoolAdmin = selectedRoles.find(role => role.roleId == Number(RoleMaster.SchoolAdmin));
    if(schoolAdmin && selectedRoles.length > 1){
      this.toasterService.warning("Other roles cannot be choosen, when School Admin role is selected!");
      this.createUserForm.controls['role'].setValue([schoolAdmin]);
    }
  }

  getPackageByPackageId(assignedPackageId: number) {
    this.packageService.getPackageByPackageId(assignedPackageId).subscribe((response: DtoPackage[] | any)=>{
      this.package = response[0];
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    });
  }

  getRoles(clientAccountId: number){
    let payload = {
      isIndividualEntity : clientAccountId == 0,
      clientAccountId : clientAccountId > 0 ? [clientAccountId] : [this.schoolId]
    } as RolePayload;

    this.schoolService.getRoles(payload).subscribe((response: Role[] | any)=>
      {
        this.roles = response.filter((x: Role)=>x.isActive == true);
        this.groupedRoles = this.getGroupedRolws(this.roles);
      },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }
  
  createRole(){
    this.dialog.open(EditUserRoleComponent, {
      width: '1000px',
      data:{
        role: {},
        packageId: this.assignedPackageId,
        clientAccountId: this.clientAccountId,
        schoolId: this.schoolId
      }
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.event == MatDialogCloseEvent.SUCCESS){
        this.getRoles(this.clientAccountId);
      }
    });
  }
  
  setPhoneNumber(countryCode: string, nationalNumber: string) {
    let examplePhoneNumber = `+${countryCode}${nationalNumber}`;
    let formattedNumber = this.phoneNumberUtil.format(
      this.phoneNumberUtil.parse(examplePhoneNumber),
      PhoneNumberFormat.INTERNATIONAL
    );
    this.createUserForm.patchValue({ contactNumber: formattedNumber });
  }

  resendActivation(){
    this.schoolService.resendActivationInvite(this.data.userDetail.userId)
    .subscribe({
    next: (response: any) => {
      if(response.isSuccess===false)
        this.toasterService.error(`${this.data.userDetail.emailId}: ${response.message}`, "Resend Activation Invite");
      else
        this.toasterService.success(`Activation invite resent to ${this.data.userDetail.emailId}`, "Resend Activation Invite");
    },
    error: (err: any) => {
      this.toasterService.error(`Activation invite could not be resent to ${this.data.userDetail.emailId}`, "Resend Activation Invite");
    }
  });
    
  }
  createUser(){
    let userDetails = JSON.parse(JSON.stringify(this.createUserForm.value));
    delete userDetails['modules'];
    delete userDetails['subCategories'];
    let parsedNumber = this.phoneNumberUtil.parse(this.createUserForm.get('contactNumber')?.value);
    let countryCode = parsedNumber.getCountryCode();
    let nationalNumber = parsedNumber.getNationalNumber();

    userDetails.countryCode = countryCode;
    userDetails.phoneNumber = nationalNumber;

    const schoolUserformData = new FormData();
    if(this.schoolUserUploadFileList.length){
      this.schoolUserUploadFileList[0].schoolUserMailId = userDetails.emailId;
  
      userDetails.UploadedFiles = this.schoolUserUploadFileList[0].files;
      this.schoolUserUploadFileList[0].files.forEach((file: File) => {
        schoolUserformData.append('file', file, file.name);
      });
    }

    this.dialogRef.close({event:MatDialogCloseEvent.SUCCESS, data: { userDetails, fileData: schoolUserformData }});
  }

  closePopup(){
    this.excelData = [];
    this.dialogRef.close({event:MatDialogCloseEvent.CANCELLED});
  }

  bulkUpload(){
    if (this.uploadFileInput) {
      this.uploadFileInput.nativeElement.click();
    }
  }

  loadExcelData(event: any) {
    const target: DataTransfer = <DataTransfer>(event.target);

    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();

    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      const data: any[][] = XLSX.utils.sheet_to_json(ws, { header: 1 });

      // Assuming your data starts from the second row (index 1) 
      this.excelData = data.slice(1)
      .filter((row: any[]) => row.some(cell => cell !== undefined && cell !== null && cell !== ''))
      .map((row: any[]) => ({
        title: row[1] || '',
        firstName: row[2] || '',
        lastName: row[3] || '',
        emailId: row[4] || '',
        countryCode: row[5] || '',
        phoneNumber: row[6] || '',
        role: null // Role to be added manually
      }));
    };
    reader.readAsBinaryString(target.files[0]);
    this.isBulkUpload = true;
    event.target.value = null;
  }

  openEditUserDialog(userDetail: any = {}, index: number){
    userDetail.isBulkUploadEdit = true;
    console.log("Opened from Self(Bulk Upload)");
    
    this.dialog.open(AddSchoolUserComponent, {
      width: '800px',
      data: {
        userDetail: userDetail,
        assignedPackageId: this.assignedPackageId,
        roles: this.roles.filter(x=>x.isActive == true),
        schoolId: this.schoolId,
        clientAccountId: this.clientAccountId,
        allowBulkUpload: false
      }
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.event == MatDialogCloseEvent.SUCCESS && popupEvent?.data.userDetails){
          this.excelData[index].title = popupEvent?.data.userDetails.title;
          this.excelData[index].firstName = popupEvent?.data.userDetails.firstName;
          this.excelData[index].lastName = popupEvent?.data.userDetails.lastName;
          this.excelData[index].countryCode = popupEvent?.data.userDetails.countryCode;
          this.excelData[index].phoneNumber = popupEvent?.data.userDetails.phoneNumber;
          this.excelData[index].emailId = popupEvent?.data.userDetails.emailId;
          this.excelData[index].uploadedFiles = popupEvent?.data.userDetails.UploadedFiles;
          this.excelData[index].schoolId = this.schoolId

          let roleList = this.roles.filter(x=> popupEvent?.data.userDetails.role.map((y: Role)=>y.roleId).includes(x.roleId));
          this.excelData[index].role = roleList;
      }
    });
  }

  downloadFile(): void {
    const blobName = 'TemplateForBulkUploadSchoolUser.xlsx'; // Specify the file name you want to download
    this.schoolService.downloadFile(blobName).subscribe((response: any) => {

      var url = response.blobUrl.toString();
      for (var i = 0; i < url.length; i++) {
        url = url.replace("~", "");
        url = url.replace("//", "%2F%2F");
        url = url.replace("/", "%2F");
        url = url.replace(":", "%3A");
    }
    console.log(url);
     var ViewDocumentUrl = "https://view.officeapps.live.com/op/view.aspx?src=" + url;
     window.open(ViewDocumentUrl, "_blank");
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    });
  }

  areAllDetailsFilled(): boolean {
    return this.excelData.every(detail => 
      detail.title && 
      detail.firstName && 
      detail.lastName && 
      detail.emailId && 
      detail.countryCode && 
      detail.phoneNumber && 
      detail.role
    );
  }

  onFileSelected(event: any) {
    if (!this.schoolUserUploadFileList[0]) {
      this.schoolUserUploadFileList[0]= { schoolUserMailId: null, files: [] };
    }

    let filesExist = event.target.files.length;
    if (filesExist > 0) {
      for (let i = 0; i < filesExist; i++) {
        if (event.target.files && event.target.files[i]) {
          if(event.target.files[i].size <= this.maxSize){
            let _object: File = event.target.files[i];
            this.schoolUserUploadFileList[0].files.push(_object);
          }
          else{
            this.toasterService.warning('File size must be less than 1 MB.');
          }
        }
      }
      this.sharedService.changeUploadingStatus(false);
      this.sharedService.setUploadedFile(this.schoolUserUploadFileList[0].files);
      this.selectedFileCount = this.schoolUserUploadFileList[0].files.length;
      this.schoolUserFileInputs!.nativeElement.value = null;
    }
  }

  createBulkUsers(){
    if(this.excelData.length > this.availableNumberOfSchoolUsersToCreate){
      this.availableNumberOfSchoolUsersToCreate > 0 ?
      this.toasterService.warning(`Only ${this.availableNumberOfSchoolUsersToCreate} more user(s) can be created under this school.`) :
      this.toasterService.warning('Maximum number of school users for this school has already been created');
      return;
    }
    
    this.schoolService.createSchoolUser(this.excelData).subscribe((response: any) => {
      if (response.isSuccess) {
        this.toasterService.success('School users created successfully!', 'Success');
        let isBulkUploaded = true;
        let userDetails = this.excelData;
        this.schoolService.getSchoolUsers(this.userEmail ,this.schoolId).subscribe((response: DtoSchoolUser[] | any)=>{
          if (response != null) {
            response.forEach((user: DtoSchoolUser) => {
              let matchedSchoolUserUploadFileList = this.findSchoolUserUploadFileListByMail(user.emailId!);
              if (matchedSchoolUserUploadFileList) {
                let formData = new FormData();
                matchedSchoolUserUploadFileList.forEach((file: File) => {
                  formData.append('file', file, file.name);
                });
                this.uploadDocument(formData, DocumentType.EntityAudience, user.userId.toString());
              }
            });
        }
        },(err: HttpErrorResponse)=>{
          if(err.error){
            this.toasterService.error(err.error, "Error");
          }
        })
        setTimeout(()=>{
          this.dialogRef.close({ event:MatDialogCloseEvent.SUCCESS, data: { isBulkUploaded, userDetails }});
        },3000)
      }
    }, (errorResponse: HttpErrorResponse) => {
      if(errorResponse.error){
        this.toasterService.error(errorResponse.error, "Error");
      }
    })
  }

  findSchoolUserUploadFileListByMail(email: string) {
    const matchingRecord = this.excelData.find((data: any) => data.emailId === email);
    return matchingRecord ? matchingRecord.uploadedFiles : null;
  }

  getFilesForSchoolUser(): File[] {
    const schoolUserUploadFileList = this.schoolUserUploadFileList[0];
    return schoolUserUploadFileList ? schoolUserUploadFileList.files || [] : [];
  }

  deleteItem(index: number): void {
    this.excelData.splice(index, 1);
    if(this.excelData.length == 0){
      this.isBulkUpload = false;
    }
  }

  checkFormValidityExceptRole(): boolean {
    // const roleControl = this.createUserForm.get('role');
  
    // if (roleControl) {
    //   this.createUserForm.removeControl('role');
    // }
  
    // Check form validity
    const isValid = this.createUserForm.valid;
  
    // Re-add role
    // if (roleControl) {
    //   this.createUserForm.addControl('role', roleControl);
    // }
    return isValid;
  }

  uploadDocument(formData: FormData, documentTypeId: string, referenceId: string) {
    this.matAccountService.uploadDocument(formData, documentTypeId, referenceId).subscribe(
      (res: any) => {
        if (res) {
          console.log("Uploaded Successfully");
        }
      },
      (error: HttpErrorResponse) => {
        if(error.error){
          this.toasterService.error(error.error, "Error");
        }
      }
    );
  }

  uploadFromLocal(event: Event, triggeredManually = false): void {
    if (!triggeredManually) {
      event.preventDefault();
      this.sharedService.setUploadedFile(this.getFilesForSchoolUser());
      this.dialog.open(ConfirmDialogComponent, { width: '675px', data: {
        hideUpload: false,
        isParentUpload: true
      }}).afterClosed().subscribe(() => {
        this.selectedFileCount = this.schoolUserUploadFileList.length;
      });
    }
    if (this.schoolUserFileInputs) {
      this.schoolUserFileInputs.nativeElement.click();
    }
  }
  
}
